<template>
    <page-layout :disable-padding="true" :footer-box-shadow="false" class="page-container">
        <template slot="default">
            <div class="page-content">
                <div class="margin-bottom-large">
                    <g-typography tag="h2" font-weight="semibold" value="Check Your Email!"/>
                </div>
                <div class="margin-bottom-large">
                    <g-typography>
                        To complete the process, click on the link that was sent to {{email}}.
                    </g-typography>
                </div>
                <g-typography v-if="!isWhiteLabeled" tag="h5" color="secondary" value="Your verification email will come from support@grin.co."/>
                <div class="back-container">
                    <g-link :to="{name: 'v2.account.verify'}" tag="router-link" type="normal">Go Back</g-link>
                </div>
            </div>
        </template>
        <template slot="footer">
            <div v-if="!isWhiteLabeled" class="page-footer">
                <powered-by-grin/>
            </div>
        </template>
    </page-layout>
</template>

<script>
    import * as _ from 'lodash';
    import PageLayout from "../../layouts/PageLayout";
    import TitleBar from "../../library/TitleBar";

    export default {
        name: "AccountVerificationEmailSentView",
        components: {
            TitleBar,
            PageLayout,
        },
        props: {
            contact: {
                type: Object,
            },
            isWhiteLabeled: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            email() {
                return _.get(this, 'contact.email', '');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .page-container {
        & ::v-deep .page-content {
            padding: $g-spacing-9 $g-spacing-6 $g-spacing-6;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
        }
        & ::v-deep .page-footer {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: $g-spacing-6;
        }
        & .margin-bottom-normal {
            margin-bottom: $g-spacing-5;
        }

        & .margin-bottom-large {
            margin-bottom: $g-spacing-6;
        }
    }

    .back-container {
        margin-top: $g-spacing-7;
    }
</style>
